import type { P5OfertaComarcalRow } from "./useP5ChartData";
import styles from "./P5OfertaComarcalTableCard.module.css";

interface P5OfertaComarcalTableCardProps {
  data: P5OfertaComarcalRow[];
}

const P5OfertaComarcalTableCard = ({ data }: P5OfertaComarcalTableCardProps) => {
  return (
    <div className={styles.card} data-chart-card>
      <h2 className={styles.title}>Cobertura d&apos;oferta universitària per comarca</h2>
      <p className={styles.subtitle}>
        Resum complet de comarques: indica si hi ha oferta universitària i en quins sectors
        (considerant places &gt; 0).
      </p>

      <div className={styles.tableWrap}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Comarca</th>
              <th>Oferta universitària</th>
              <th>Sectors amb oferta</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row) => (
              <tr key={row.nom_comarca}>
                <td className={styles.comarcaCell}>{row.nom_comarca}</td>
                <td>
                  <span className={row.teOferta ? styles.badgeYes : styles.badgeNo}>
                    {row.teOferta ? "Sí" : "No"}
                  </span>
                </td>
                <td>
                  {row.sectorsAmbOferta.length > 0 ? (
                    <div className={styles.sectorsList}>
                      {row.sectorsAmbOferta.map((sector) => (
                        <span key={`${row.nom_comarca}-${sector}`} className={styles.sectorTag}>
                          {sector}
                        </span>
                      ))}
                    </div>
                  ) : (
                    <span className={styles.noOfertaText}>Sense oferta</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default P5OfertaComarcalTableCard;
